import {
  Autocomplete,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

import { IOption } from 'interfaces';
import { ReactNode } from 'react';

export const CustomTextField = styled(TextField)(({ theme }) => ({
  opacity: 1,
  backgroundColor: theme.palette.grey.A100,
  border: 0,
  borderRadius: '6px',
  fontSize: '18px',
  fontWeight: 500,
  outline: 'none',
  marginTop: '5px',
  width: '100%',
  color: theme.palette.text.secondary,
  '& .MuiOutlinedInput-root': {
    padding: '0 13px 0 0 !important',
  },
  '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
    padding: '11px 14px',
    borderRadius: '6px',
  },
  '& .MuiOutlinedInput-root .MuiSvgIcon-root': {
    color: theme.palette.text.secondary,
  },
  '& .MuiOutlinedInput-root .MuiInputAdornment-root .MuiIconButton-root': {
    color: theme.palette.text.secondary,
  },
  '& .MuiOutlinedInput-root.Mui-focused': {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input': {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.grey.A400,
    borderRadius: '6px',
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
    borderWidth: '1px',
  },
}));

interface PrimaryAutoCompleteProps {
  label:string,
  value:IOption,
  options:IOption[],
  placeholder?:string,
  startAdornment?:ReactNode,
  endAdornment?:ReactNode,
  setValue: (value:IOption) => void,
  onChange?: (e:any)=>void,
  groupBy?: (option: IOption) => string,
}

const PrimaryAutoComplete = ({
  label, value, options, setValue, onChange, placeholder, startAdornment, endAdornment, groupBy,
}:PrimaryAutoCompleteProps) => (
  <Autocomplete
    options={options}
    autoHighlight
    value={value}
    isOptionEqualToValue={(option, currentValue) => option.value === currentValue.value}
    onChange={(_event: any, newValue: IOption | null) => {
      setValue(newValue as IOption);
      if (onChange !== undefined) {
        onChange(newValue?.value);
      }
    }}
    groupBy={groupBy ?? undefined}
    getOptionLabel={(option) => option.text as string}
    renderInput={(params) => (
      <>
        {label && <Typography variant="body1">{label}</Typography>}
        <CustomTextField
          placeholder={placeholder}
          {...params}
          InputProps={{
            ...params.InputProps,
            startAdornment,
            endAdornment,
          }}
        />
      </>

    )}
  />
);

PrimaryAutoComplete.defaultProps = {
  placeholder: '',
  startAdornment: <InputAdornment position="start" />,
  endAdornment: <InputAdornment position="end" />,
  onChange: (_e:any) => {},
  groupBy: null,
};

export default PrimaryAutoComplete;
